<template>
    <div>
        <Echart :options="options" id="toprightchart" height="350px" width="100%"></Echart>
    </div>
</template>

<script>
    import request from '@/utils/request';
    import Echart from '@/common/echart'

    export default {
        data() {
            return {
                options: {
                    legend: {
                        top: 'top'
                    },
                    toolbox: {
                        show: false,
                        feature: {
                            mark: {
                                show: true
                            },
                            dataView: {
                                show: true,
                                readOnly: false
                            },
                            restore: {
                                show: true
                            },
                            saveAsImage: {
                                show: true
                            }
                        }
                    },

                    series: [{
                        name: '',
                        type: 'pie',
                        radius: [40, 50],
                        center: ['50%', '50%'],
                        roseType: 'area',
                        itemStyle: {
                            borderRadius: 10
                        },
                        label: {
                            normal: {
                                show: true,
                                formatter: '{b}:{c}人'
                            }
                        },
                        data: []
                    }]
                }
            }
        },
        components: {
            Echart
        },
        created() {
            let area = this.$route.query.area;
            let code = this.$route.query.code;
            let level = this.$route.query.level;
            var data = {}
            if (level == '2') {
                data = {area: area}
            } else {
                data = {code: code}
            }
            request({
                url: this.$root.api + `/api/dbz/daping/getBzRsByArea/` + 'pggyrs',
                method: 'get',
                data: data
            }).then(res => {
                console.log('pggyrs--', res)
                this.options.series[0].data = res.data
                //   this.options.series[0].data=[{"name":"三高","value":51233},{"name":"慢阻肺","value":10577},{"name":"糖尿病肾病","value":2211},{"name":"眩晕综合征","value":1341},{"name":"偏头痛","value":1005},{"name":"急性气管炎","value":323},{"name":"慢性肺源性心脏病","value":1546}]
            })
        }
    }
</script>

<style></style>
